module.exports = __webpack_public_path__ + "static/media/snaplogo.b00f2f18.png";